export { setup_actions } from './locations';
export { register_lp_widgets } from './lp-init';

// default roots
export const roots: string = `{}`;
